'use strict'

const Action = require('./actions.json')

Object.keys(Action).forEach(serviceName => {

    const service = Action[serviceName]

    if ('object' !== typeof service) {
        delete Action[serviceName]
        return
    }

    Object.keys(service).forEach(activityName => {
        service[activityName] = `${serviceName}:${activityName}`
    })

})

module.exports = Action



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/action.js
// module id = 112
// module chunks = 51